module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Zosk")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I had walked for some hours in the direction of Ko-ro-ba when I was delighted to come on one of the narrow roads to the city. I recognized it, and even had I not, the cylindrical pasang stones that marked its length were each inscribed with the sign of the city and the appropriate pasang count to its walls. A Gorean pasang is approximately .7 of a mile.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The road, like most Gorean roads, was built like a wall in the earth and was intended to last a hundred generations. The Gorean, having little idea of progress in our sense, takes great care in his building and workmanship. What he builds he expects men to use until the storms of time have worn it to dust. Yet this road, for all the loving craft of the Caste of Builders which had been lavished upon it, was only an unpretentious, subsidiary road, hardly wide enough for two carts to pass. Indeed, even the main roads to Ko-ro-ba were a far cry from the great highways that led to and from a metropolis like Ar.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Surprisingly, though the pasang stones told me I was close to Ko-ro-ba, stubborn tufts of grass were growing between the stones, and occasional vines were inching out, tendril by tendril, across the great stone blocks.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was late afternoon and, judging by the pasang stones, I was still some hours from the city. Though it was still bright, many of the colorfully plumed birds had already sought their nests. Here and there swarms of night insects began to stir, lifting themselves under the leaves of bushes by the road. The shadows of the pasang stones had grown long, and, judging by the angle of these shadows, for the stones are set in such a way as to serve also as sundials, it was past the fourteenth Gorean Ahn, or hour. The Gorean day is divided into twenty Ahn, which are numbered consecutively. The tenth Ahn is noon, the twentieth, midnight. Each Ahn consists of forty Ehn, or minutes, and each Ehn of eighty Ihn, or seconds.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I wondered if it would be practical to continue my journey. The sun would soon be down, and the Gorean night is not without its dangers, particularly to a man on foot.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It is at night that the sleen hunts, that six-legged, long-bodied mammalian carnivore, almost as much a snake as an animal. I had never seen one, but had seen the tracks of one seven years before.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Also, at night, crossing the bright disks of Gor's three moons might occasionally be seen the silent, predatory shadow of the ul, a giant pterodactyl ranging far from its native swamps in the delta of the Vosk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Perhaps most I dreaded those nights filled with the shrieks of the vart pack, a batlike swarm of flying rodents, each the size of a small dog. They could strip a carcass in a matter of minutes, each carrying back some fluttering ribbon of flesh to the recesses of whatever dark cave the swarm had chosen for its home. Moreover, some vart packs were rabid.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("One obvious danger lay in the road itself, and the fact that I had no light. After dark, various serpents seek out the road for its warmth, its stones retaining the sun's heat longer than the surrounding countryside. One such serpent was the huge, many-banded Gorean python, the hith. One to be feared even more perhaps was the tiny ost, a venomous, brilliantly orange reptile little more than a foot in length, whose bite spelled an excruciating death within seconds.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Accordingly, in spite of my eagerness to return to Ko-ro-ba, I decided that I would withdraw from the road, wrap myself in my cloak and spend the night in the shelter of some rocks, or perhaps crawl into the tangle of some thorn bushes, where one might sleep in relative security. Now that I was considering discontinuing my journey, I suddenly became acutely aware that I was both hungry and thirsty. No rations or water flask had been in the leather package found with the weapons.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I had scarcely stepped from the stones of the road when, coming down the road, each step carefully measured and solid, I saw a wide, hunched figure, bending under a gigantic bundle of sticks, strapped to his back by two cords which he held twisted in his fists in front of his body. His stature and burden proclaimed him a member of the Caste of Carriers of Wood, or Woodsmen, that Gorean caste which, with the Caste of Charcoal Makers, provides most of the common fuel for the Gorean cities.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The weight the man was carrying was prodigious, and would have staggered men of most castes, even that of the Warriors. The bundle reared itself at least a man's height above his bent back, and extended perhaps some four feet in width. I knew the support of that weight depended partly on the skillful use of the cords and back, but sheer strength was only too obviously necessary, and this man, and his caste brothers, over the generations, had been shaped to their task. Lesser men had turned outlaw or died. In rare cases, one might have been permitted by the Council of High Castes to raise caste. None of course would accept a lower caste, and there were lower castes, the Caste of Peasants, for example, the most basic caste of all Gor.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man approached more closely. His eyes were almost covered with a white, shaggy, inverted bowl of hair, matted with twigs and leaves. The whiskers had been scraped from his face, probably by the blade of the broad, double-headed wood ax bound on top of the bundle. He wore the short, tattered sleeveless robe of his trade, with its leather back and shoulders. His feet were bare, and black to the ankles.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I stepped into the road before him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Tal,\" I said, lifting my right arm, palm inward, in a common Gorean greeting.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The shaggy creature, broad, powerful, monstrous in the proud deformation of his craft, stood before me, his feet planted firmly on the road. His head lifted. Its wide, narrow eyes, pale like water, regarded me through the brush of hair that almost concealed them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In spite of his slow reaction to my presence, his deliberate and patient movements, I gathered that he was surprised. He had apparently not expected to meet anyone on this road. That puzzled me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Tal,\" he said, his voice thick, almost less than human.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I sensed that he was considering how quickly he could get to the ax bound across the bundle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I mean you no harm,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What do you want?\" asked the carrier of wood, who must now have noticed that my shield and accouterments bore no insignia, and would have concluded that I was an outlaw.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am not an outlaw,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He obviously did not believe me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am hungry,\" I said. \"I have had nothing to eat in many hours.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I, too, am hungry,\" he said, \"and have had nothing to eat in many hours.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Is your hut near?\" I asked. I knew it would be from the time of day at which I had encountered him. The sun regulates the schedule of most Gorean crafts and the woodsman would now be returning with his day's cutting.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I mean you and your Home Stone no harm,\" I said. \"I have no money and cannot pay you, but I am hungry.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"A warrior takes what he wishes,\" said the man.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not wish to take anything from you,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He regarded me, and I thought the trace of a smile cracked through the stubbled leather of his broad face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I have no daughter,\" he said. \"I have no silver, and no goods.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Then I wish you prosperity,\" I laughed, \"and will be on my way.\" I passed him and continued down the road.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I had moved but a few steps when his voice arrested me. It was hard to understand the words, for those of the lonely Caste of Woodsmen do not often speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I have peas and turnips, garlic and onions in my hut,\" said the man, his bundle like a giant's hump on his back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The Priest-Kings themselves,\" I said, \"could not ask for more.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Then, Warrior,\" said the man, issuing Gor's blunt invitation to a low-caste dinner, \"share my kettle.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am honored,\" I said, and I was.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Whereas I was of high caste and he of low, yet in his own hut he would be, by the laws of Gor, a prince and sovereign, for then he would be in the place of his own Home Stone. Indeed, a cringing whelp of a man, who would never think of lifting his eyes from the ground in the presence of a member of one of the high castes, a crushed and spiritless churl, an untrustworthy villain or coward, an avaricious and obsequious peddler often becomes, in the place of his own Home Stone, a veritable lion among his fellows, proud and splendid, generous and bestowing, a king, be it only in his own den.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Indeed, frequent enough were the stories where even a warrior was overcome by an angry peasant into whose hut he had intruded himself, for in the vicinity of their Home Stones men fight with all the courage, savagery and resourcefulness of the mountain larl. More than one are the peasant fields of Gor which have been freshened with the blood of foolish warriors.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The broad-chested carrier of wood was grinning from ear to ear. He would have a guest tonight. He would speak little himself, being unskilled in speech, and being too proud to form sentences which he knew would most likely be stumbling and ungrammatical, but would sit by the fire until dawn refusing to let me sleep, wanting me to talk to him, to tell him stories, to recount adventures, to give him news of faraway places. What I said, I knew, would be less important than the fact that something was said, that he had not been alone again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am Zosk,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I wondered if it were a use-name, or his real name. Members of low castes often call themselves by a use-name, reserving the real name for intimates and friends, to protect it against capture by a sorcerer or worker of spells who might use it to do them harm. Somehow I sensed that Zosk was his real name.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Zosk of what city?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The low-slung, broad frame seemed to stiffen. The muscles in his legs seemed suddenly to bulge like cable. The rapport I had felt with him seemed suddenly gone, like a sparrow flown or a leaf suddenly torn from a branch. \"Zosk...\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Of what city?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Of no city,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Surely,\" I said, \"you are of Ko-ro-ba.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The squat, misformed giant of a man seemed almost to recoil as if struck, and to tremble. I sensed that this simple, unaffected primate of a man was suddenly afraid. Zosk, I felt, would have faced a larl armed only with his ax, but yet, here, he seemed frightened. The great fists holding the cords of the bundle of wood turned white; the sticks rattled in the bundle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am Tarl Cabot,\" I said. \"Tarl of Ko-ro-ba.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Zosk uttered an inarticulate cry, and began to stumble backwards. His hands fumbled on the cords and the great bundle of wood loosened and clattered to the stone flooring of the road. Turning to run his foot slipped on one of the sticks and he fell. He fell almost on top of the ax which lay on the road. Impulsively, as though it were a life-giving plank in the maelstrom of his fear, he seized the ax.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With the ax in his hands, suddenly he seemed to remember his caste, and he crouched in the road, there in the dusk, a few feet from me, like a gorilla clutching the broad-headed ax, breathing deeply, sucking in the air, mastering his fear.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His eyes glared at me through the grizzled, matted locks of his hair. I could not understand his fear, but I was proud to see him master it, for fear is the great common enemy of all living things, and his victory I felt somehow was also mine. I remembered once when I had feared thus in the mountains of New Hampshire, and how shamefully I had yielded to my fear and had run, a slave to the only degrading passion of man.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Zosk straightened as much as his giant bow of a backbone would allow him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was no longer afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He spoke slowly. His voice was thick, but it was fully under his control.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Say you are not Tarl Cabot of Ko-ro-ba,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But I am,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I ask your favor,\" said Zosk, his voice thick with emotion. He was pleading. \"Say you are not Tarl Cabot of Ko-ro-ba.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am Tarl Cabot of Ko-ro-ba,\" I repeated firmly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Zosk lifted his ax.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It seemed light in his massive grip. I felt it could have felled a small tree with a single blow. Step by step, he approached me, the ax held over his shoulder with both hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At last he stopped before me. I thought there were tears in his eyes. I made no move to defend myself. Somehow I knew Zosk would not strike. He struggled with himself, his simple wide face twisted in agony, his eyes tortured.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"May the Priest-Kings forgive me!\" he cried.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He threw down the ax, which rang on the stones of the road to Ko-ro-ba. Zosk sank down and sat cross-legged in the road, his gigantic frame shaken with sobs, his massive head buried in his hands, his thick, guttural voice moaning with distress.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At such a time a man may not be spoken to, for according to the Gorean way of thinking pity humiliates both he who pities and he who is pitied. According to the Gorean way, one may love but one may not pity. So I moved on.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I had forgotten my hunger. I no longer considered the dangers of the road.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I would make it to Ko-ro-ba by dawn.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b97ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 78
// module chunks = 0